var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M244.426,360.546c4.884-3.648,9.128-4.841,15.694-6.034c6.569-1.193,13.506-3.228,17.144-4.21 c3.67-1.016-12.328,4.841-16.403,5.999C256.854,357.528,244.426,360.546,244.426,360.546L244.426,360.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M270.865,350.274c-1.314-8.252,1.952-16.94,9.429-20.41 C282.046,335.86,276.69,346.03,270.865,350.274L270.865,350.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M283.629,345.997c-4.008-6.904,2.728-15.763,7.746-20.074 C293.699,330.066,289.623,342.426,283.629,345.997L283.629,345.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M295.383,340.675c-4.244-5.894,0.809-16.201,6.198-20.276 C303.669,326.227,301.58,336.666,295.383,340.675L295.383,340.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M307.171,333.266c-3.906-5.558-1.177-14.18,4.446-19.805 C315.626,318.11,312.189,328.147,307.171,333.266L307.171,333.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M316.637,325.856c-3.267-5.255,0.739-17.816,5.994-21.287 C324.887,309.217,323.203,322.354,316.637,325.856L316.637,325.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M324.146,323.87c-0.943-7.511,12.192-15.83,17.548-15.594 C341.121,314.404,335.496,321.14,324.146,323.87L324.146,323.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M316.803,332.355c6.198-6.33,18.155-6.33,22.397-5.018 C338.09,331.043,323.945,339.093,316.803,332.355L316.803,332.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M308.316,338.722c8.69-2.325,14.314-4.211,19.501,1.177 C324.146,344.548,310.068,343.168,308.316,338.722L308.316,338.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M295.923,344.348c8.319-4.447,18.389,2.121,19.905,5.927 C306.566,354.147,295.754,345.323,295.923,344.348L295.923,344.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M284.537,350.712c7.578-2.897,16.268,0.943,19.703,5.187 C300.199,357.853,289.623,359.974,284.537,350.712L284.537,350.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M274.166,353.978c8.69-0.975,17.007,5.625,18.827,9.364 C281.944,364.419,277.667,361.086,274.166,353.978L274.166,353.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M271.37,360.546c-4.817-3.648-9.06-4.841-15.628-6.034c-6.569-1.193-13.506-3.228-17.209-4.21 c-3.604-1.016,12.393,4.841,16.468,5.999C259.042,357.528,271.37,360.546,271.37,360.546L271.37,360.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M244.931,350.274c1.379-8.252-1.887-16.94-9.431-20.41 C233.816,335.86,239.172,346.03,244.931,350.274L244.931,350.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M232.233,345.997c4.076-6.904-2.728-15.763-7.746-20.074 C222.162,330.066,226.239,342.426,232.233,345.997L232.233,345.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M220.412,340.675c4.311-5.894-0.742-16.201-6.131-20.276 C212.16,326.227,214.282,336.666,220.412,340.675L220.412,340.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M208.657,333.266c3.873-5.558,1.18-14.18-4.412-19.805 C200.238,318.11,203.673,328.147,208.657,333.266L208.657,333.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M199.228,325.856c3.334-5.255-0.742-17.816-5.996-21.287 C190.908,309.217,192.659,322.354,199.228,325.856L199.228,325.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M191.649,323.87c1.011-7.511-12.125-15.83-17.481-15.594 C174.741,314.404,180.266,321.14,191.649,323.87L191.649,323.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M199.059,332.355c-6.198-6.33-18.153-6.33-22.397-5.018 C177.839,331.043,191.917,339.093,199.059,332.355L199.059,332.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M207.546,338.722c-8.69-2.325-14.314-4.211-19.501,1.177 C191.649,344.548,205.794,343.168,207.546,338.722L207.546,338.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M219.872,344.348c-8.285-4.447-18.322,2.121-19.838,5.927 C209.297,354.147,220.041,345.323,219.872,344.348L219.872,344.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M231.222,350.712c-7.544-2.897-16.2,0.943-19.635,5.187 C215.662,357.853,226.239,359.974,231.222,350.712L231.222,350.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M241.731,353.978c-8.757-0.975-17.075,5.625-18.86,9.364 C233.985,364.419,238.229,361.086,241.731,353.978L241.731,353.978z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC850"
    },
    d: "M147.966,229.194c0,0-2.412,3.146,1.685,11.114s1.154,17.164,5.568,20.106 c4.414,2.943,0.185,8.778,5.242,12.664c5.056,3.887,18.345,12.831,27.517,13.877c9.172,1.045,18.082-8.222,23.374-1.382 s4.136,11.661,9.128,12.193s4.992-1.675,4.625-4.985s3.31-12.505,11.77-12.505s17.422-1.007,31.7-6.389 c14.278-5.382,21.266-7.956,23.105-16.416c1.839-8.46,7.068-18.462,17.143-13.828c10.076,4.633,9.398,2.46,12.495,0.236 s13.482,4.209,15.83,0.809c2.348-3.401-18.377-20.224-17.209-29.1c1.166-8.875,3.961-16.247,12.495-16.975 c8.534-0.728,6.327-10.291,15.155-15.073c8.828-4.781,12.894-5.329,19.872-12.412s25.329-21.421,25.329-21.421 s-35.701,17.097-42.841,18.66c-7.14,1.564-10.087,11.863-29.949,17.38s-20.966,7.724-36.046,11.034 c-13.581,2.982-44.26,1.98-62.408-3.843c-2.503-0.803-4.99,1.173-4.768,3.793c0.747,8.821,0.538,24.681-10.176,27.142 c0,0-14.603-10.906-23.798-6.125c-9.195,4.781-15.735,21.834-22.58,19.192C153.379,234.298,152.483,223.353,147.966,229.194z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/cy.247ec9bf5987af1fec2afa1615019cf6.svg";
export { ForwardRef as ReactComponent };